<div
  *ngIf="active"
  class="fixed inset-0 min-h-screen bg-gradient-to-b from-razberry-400 via-razberry-500 to-blueberry-500 text-grape-500"
  style="z-index: 99999"
>
  <iframe (load)="onLoad()" class="w-full h-full" class.hidden="!isLoaded" #iframe [src]="url  | safe"></iframe>
</div>
